import { Component, OnInit, Input } from '@angular/core';
import { AdOptions, AdSize, AdPosition } from 'capacitor-admob';
import { Plugins } from '@capacitor/core';
import { Storage } from '@ionic/storage-angular';
import { IImmoCalcHistoryData } from 'src/app/interfaces/IImmoCalcHistoryData';
import { IImmoCalcData } from 'src/app/interfaces/IImmoCalcData';
import { ActivatedRoute, Router } from '@angular/router';
const { AdMob, Toast } = Plugins;
import { AdMobFree, AdMobFreeBannerConfig } from '@ionic-native/admob-free';
import { AdMobFreeInterstitialConfig, AdMobFreeRewardVideoConfig } from '@ionic-native/admob-free/ngx';
import { AdmobService } from '../../services/admob.service';
import { AlertController, Platform } from '@ionic/angular';
import { IImmoCalcHouse } from 'src/app/interfaces/IImmoCalcHouse';

@Component({
  selector: 'my-houses-apartments',
  templateUrl: './my-houses-apartments.component.html',
  styleUrls: ['./my-houses-apartments.component.scss'],
})
export class MyHousesApartmentsComponent implements OnInit {
  @Input() name: string;
  houses: IImmoCalcHouse[] = [];
  activeHouse: IImmoCalcHouse;
  houseId: string;


  constructor(private storage: Storage,
    private router: Router,
    platform: Platform,
    private route: ActivatedRoute,
    private alertController: AlertController) {

    route.params.subscribe(async val => {
      this.houseId = this.route.snapshot.paramMap.get('houseId');


      await this.storage.create();

      this.houses = await this.storage.get('houses');
      if (!this.houses || !this.houses.length) {
        this.houses = [];
        await this.storage.set('houses', this.houses);

      }

      const houses = this.houses.filter(h => h.id == this.houseId);
      if (!houses || !houses.length) {
        this.houseId = 'error';
      }
      else {
        this.activeHouse = houses[0];
        console.log(this.activeHouse);
      }
    });

  }

  async openImmoCalcData(immoCalcData: IImmoCalcData) {
    await this.storage.set('immoCalcData', immoCalcData);
    this.router.navigateByUrl('/immo/calc');
  }

  async ngOnInit() {

  }

  valueSum(h: IImmoCalcHouse) {
    return h.apartments.map(a => a.startBalance).reduce((a, b) => a + b);
  }

  openApartment(h: IImmoCalcHouse, a: IImmoCalcData) {
    this.router.navigate(['/immo/calc', { houseId: h.id, apartmentId: a.id }]);
  }

  getActiveHouseName() {
    this.activeHouse ? 'Apartments von ' + this.activeHouse.name : 'lade...';
  }


  async delete(e: any, apartment: IImmoCalcData) {

    e.stopPropagation();

    const alert = await this.alertController.create({
      header: 'Wohnung löschen',
      message: 'Wohnung wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel',
          handler: () => {
            console.log('they hit cancel');
            return Promise.resolve(false);
          }
        }, {
          text: 'Löschen',
          handler: () => {
            console.log('they hit ok');
            this.deleteApartment(apartment);
            return Promise.resolve(true);
          }
        }
      ]
    });

    return await alert.present();
  }

  async edit(e: any, apartment: IImmoCalcData) {
    e.stopPropagation();
  }

  async deleteApartment(apartment: IImmoCalcData) {
    for (let i = 0; i < this.activeHouse.apartments.length; i++) {
      if (apartment.id == this.activeHouse.apartments[i].id) {
        this.activeHouse.apartments.splice(i, 1);
        await this.storage.set('houses', this.houses);
        return;
      }
    }

    await this.updateActiveHouses();
  }


  async addApartment() {
    this.activeHouse.apartments.push(
      {
        id: Date.now().toString(), // 2Do: GUID
        name: 'Wohnung',
        startBalance: 200000,
        startYear: 0,
        endYear: 30,
        income: 30000,
        savingsRate: 0,
        interest: 6,
        percentRule: 3,
        stopAfter3percentRule: false,
        rentPerMonth: 600,
        immoStartFee: 11,
        immoEquity: 20,
        immoInterest: 2,
        synchInterest: true,
        immoValueGroth: 4
      }
    );

    await this.updateActiveHouses();
  }

  async updateActiveHouses() {
    for (let i = 0; i < this.houses.length; i++) {
      if (this.houses[i].id == this.activeHouse.id) {
        this.houses[i] = this.activeHouse;
        break;
      }
    }
    await this.storage.set('houses', this.houses);
  }
}
